import React, { Component } from "react";
import "../Styles/SvgCommand.css";

const AscSortIcon = (props) => {
  return (
    <svg
      className="svgSortCommandPassive"
      height="13"
      viewBox="0 0 27 27"
      width="13"
      onClick={props.onClick}
    >
      <path
        clipRule="evenodd"
        d="M26.711,20.273l-9.999-9.977  c-0.395-0.394-1.034-0.394-1.429,0v0h0l-9.991,9.97c-0.66,0.634-0.162,1.748,0.734,1.723h19.943  C26.862,22.012,27.346,20.906,26.711,20.273z M15.998,12.433l7.566,7.55H8.432L15.998,12.433z"
        fill="#121313"
        fillRule="evenodd"
      />
    </svg>
  );
};

export default AscSortIcon;
